import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { bannerAPI } from '../../services/bannerAPI';

interface BannerState {
  banners: any[];
  totalBanners: number;
  currentPage: number;
  totalPages: number;
  isLoading: boolean;
  error: string | null;
}

const initialState: BannerState = {
  banners: [],
  totalBanners: 0,
  currentPage: 1,
  totalPages: 0,
  isLoading: false,
  error: null,
};

export const fetchBanners = createAsyncThunk(
  'banners/fetchBanners',
  async (params: { page?: number; limit?: number; search?: string }) => {
    return await bannerAPI.getAllBanners(params);
  }
);

export const createBanner = createAsyncThunk(
  'banners/createBanner',
  async (formData: FormData) => {
    return await bannerAPI.createBanner(formData);
  }
);

export const updateBanner = createAsyncThunk(
  'banners/updateBanner',
  async ({ id, formData }: { id: string; formData: FormData }) => {
    return await bannerAPI.updateBanner(id, formData);
  }
);

export const deleteBanner = createAsyncThunk(
  'banners/deleteBanner',
  async (id: string) => {
    await bannerAPI.deleteBanner(id);
    return id;
  }
);

const bannerSlice = createSlice({
  name: 'banners',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.isLoading = false;
        console.log('Banner API Response:', action.payload); // Debug log
        state.banners = action.payload.banners || [];
        state.totalBanners = action.payload.totalbanner || 0;
        state.currentPage = action.payload.page || 1;
        state.totalPages = action.payload.CurrentPages || 0;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch banners';
      })
      .addCase(createBanner.fulfilled, (state, action) => {
        state.banners.unshift(action.payload);
      })
      .addCase(updateBanner.fulfilled, (state, action) => {
        const index = state.banners.findIndex(banner => banner._id === action.payload._id);
        if (index !== -1) {
          state.banners[index] = action.payload;
        }
      })
      .addCase(deleteBanner.fulfilled, (state, action) => {
        state.banners = state.banners.filter(banner => banner._id !== action.payload);
      });
  },
});

export const { clearError } = bannerSlice.actions;
export default bannerSlice.reducer;